import { StatusIndicator, styled } from '@workday/canvas-kit-react';

export const WclStatusIndicator = styled(StatusIndicator)({
    '& span': {
        textTransform: 'none'
    }
});
